import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryMedicalImgTxtSectionColLeftCls: string;
			heHubPulsarsDiscoveryMedicalImgTxtSectionColRightCls: string;
		}
	},

	slug: string
}

class Medical extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Medical Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryMedicalImgTxtSectionColLeftCls || '', 'he_hub_pulsars_discovery_medical', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryMedicalImgTxtSectionColRightCls || '', 'he_hub_pulsars_discovery_medical', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Medical;